import { render } from "./YourDetailsHER copy.vue?vue&type=template&id=5261641d&scoped=true"
import script from "./YourDetailsHER copy.vue?vue&type=script&lang=js"
export * from "./YourDetailsHER copy.vue?vue&type=script&lang=js"

import "./YourDetailsHER copy.vue?vue&type=style&index=0&id=5261641d&lang=scss"
import "./YourDetailsHER copy.vue?vue&type=style&index=1&id=5261641d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5261641d"]])

export default __exports__